import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router';
import { connect } from 'react-redux';
import { deleteFeed, openFeedPreview } from 'redux/modules/modals/actions';
//import { toggleAlertStatus } from 'utils/api'
import FeedsList from './FeedsListNew'
import {useHistory} from 'react-router-dom';
import './style.scss';

function Feeds(props) {
    //const [mode, setMode] = useState('fetches');
    let history = useHistory();

    useEffect(() => {
        let url = history.location.pathname;
        if(url === '/' || url === '/feeds' || url === '/feeds/'){
            history.push('/feeds/fetches');
        } else {
            //setMode(guessModeBasedOnUrl(url));
        }
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, history.location.pathname]);

    // const guessModeBasedOnUrl = (url) => {
    //     if(url.includes('fetches')){
    //         return 'fetches';
    //     } else if(url.includes('groups')) {
    //         return 'groups';
    //     } else {
    //         props.history.push('/feeds/fetches');
    //     }
    // }

    // const changeMode = (selectedMode) => {
    //     if(selectedMode !== mode){
    //         setMode(selectedMode);
    //         props.history.push('/feeds/'+selectedMode);
    //     }
    // }

    return (
        <div className="fetches mt-3">
            {/*<h1 className="mb-3">Fetches</h1>*/}
                {/* <div className="feeds-nav-navbar">
                    <div
                        className={`feeds-nav-item ${mode === 'fetches' ? 'active' : ''}`}
                        onClick={() => changeMode('fetches')}
                    >
                        Newsfetches
                    </div>
                    <div
                        className={`feeds-nav-item ${mode === 'groups' ? 'active' : ''}`}
                        onClick={() => changeMode('groups')}
                    >
                        Grouped Fetches
                    </div>
                </div>
                <div className="feeds-navbar-mobile" style={{ padding: '1.25rem' }}>
                    <div className="account-mobile">
                        <InputGroupAddon addonType="prepend" className="input-group-btn">
                            <Input onChange={(e) => changeMode(e.target.value)} value={mode} type="select" name="menu">
                                <option value="fetches">Newsfetches</option>
                                <option value="groups">Grouped Fetches</option>
                            </Input>
                        </InputGroupAddon>
                    </div>
                </div> */}
                {/*<FeedsList/>*/}
                <Switch>
                    <Route exact path="/feeds/fetches" component={FeedsList} />
                    {/* <Route exact path="/feeds/groups" component={GroupsPage} /> */}
                    <Route path="/feeds/*" render={() => <FeedsList {...props} />} />
                </Switch>
        </div>
    );
}

export default connect(null, { deleteFeed, openFeedPreview })(Feeds);